export const environment = {
  production: false,
  entorno: "Desarrollo",
  buildNumber: 'InmobiliariaMassoud-UI_CI-Massoud.UI.Dev_main_20260923.2',
  appInsights: {
    instrumentationKey: '363fa37d-1684-4082-98cb-b43dd9c3f700'
  }
};
